import { render } from "./AvatarLoader.vue?vue&type=template&id=d4463e5e&scoped=true"
import script from "./AvatarLoader.vue?vue&type=script&lang=js"
export * from "./AvatarLoader.vue?vue&type=script&lang=js"

import "./AvatarLoader.vue?vue&type=style&index=0&id=d4463e5e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4463e5e"]])

export default __exports__